import ApiHttpHandler from "./apiHttpHandler";
import AuthProvider from "./AuthProvider";
import { store } from "../store";
const handler = new ApiHttpHandler();
export const createUser = (customerId, displayName, login, password, confirmPassword, role) => {
    return handler.post("auth/create-user", {
        customerId: customerId,
        displayName: displayName,
        login: login,
        password: password,
        passwordAgain: password,
        role: role,
    });
};
export const login = (username, password) => {
    return handler
        .post("auth/login", {
        login: username,
        password: password,
    })
        .then((response) => {
        if (response.access.accessToken) {
            AuthProvider.setAuthToken({
                token: response.access.accessToken,
                expiration: response.access.accessExpiresOn,
            });
            AuthProvider.setRefreshToken({
                token: response.access.refreshToken,
                expiration: response.access.refreshExpiresOn,
            });
            AuthProvider.updateUser(response.user);
        }
        return response;
    });
};
export const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    handler.post("auth/logout");
};
export const refreshAuthToken = (token) => {
    const user = store.getState().user.value;
    if (user) {
        return handler.post("auth/refresh-token", {
            userId: user.id,
            token: token,
        });
    }
    throw new Error("User is not authorized");
};
export const resetPassword = (userId, password, confirmPassword, token) => {
    return handler.put(`auth/reset-password/${userId}`, {
        password,
        confirmPassword,
        token
    });
};
export const forgotPassword = (email) => {
    return handler.put(`auth/forgot-password/`, {
        email,
    });
};
export const changeOwnPassword = (oldPassword, newPassword, confirmPassword) => {
    return handler.put(`auth/change-own-password/`, {
        oldPassword,
        password: newPassword,
        confirmPassword
    });
};
const updateUserPassword = (userId, newPassword, confirmPassword) => {
    return handler.put(`auth/change-password/${userId}`, {
        password: newPassword,
        confirmPassword
    });
};
export default {
    createUser,
    login,
    logout,
    refreshAuthToken,
    resetPassword,
    forgotPassword,
    changeOwnPassword,
    updateUserPassword
};
